import { useCallback, useRef } from "react";

import { useTherapist } from "../../../context/useTherapist";
import { TherapistAPI } from "../infrastructure/api/therapist.api";

/**
 * Marks the Plus onboarding flow as done for the current therapist.
 *
 * The flag is stored server-side so the modal never returns on another device.
 * Failures are swallowed on purpose: onboarding is a convenience surface and a
 * failed PATCH must not keep the therapist trapped behind the modal.
 */
export const useCompleteOnboarding = () => {
    const { therapist, setTherapist } = useTherapist();
    const completedRef = useRef(false);

    const completeOnboarding = useCallback(async () => {
        if (!therapist || completedRef.current) return;
        completedRef.current = true;

        setTherapist({ ...therapist, has_completed_onboarding: true });
        try {
            await TherapistAPI.update(therapist.id, { has_completed_onboarding: true });
        } catch (error) {
            // Nothing was persisted, so this was not a completion: let a later
            // exit try again instead of leaving the flag stuck unsaved.
            completedRef.current = false;
            console.error("Failed to persist onboarding completion", error);
        }
    }, [therapist, setTherapist]);

    return { completeOnboarding };
};
